/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import { forwardRef } from 'react'
import Icon from '@bluheadless/ui/src/atoms/icon/icon'

const GridAlternateIconMobSvg = forwardRef((props, svgRef) => (
	<svg
		id="prefix__Livello_2"
		data-name="Livello 2"
		viewBox="0 0 24 24"
		width={props.width || (props.height && Math.floor(+props.height * 1)) || 24}
		height={props.height || (props.width && Math.floor(+props.width / 1)) || 24}
		xmlnsXlink="http://www.w3.org/1999/xlink"
		xmlns="http://www.w3.org/2000/svg"
		fontSize="medium"
		ref={svgRef}
		{...props}
	>
		<defs id="prefix__defs2">
			<linearGradient id="prefix__swatch7">
				<stop offset={0} id="prefix__stop7" stopColor="currentColor" stopOpacity={1} />
			</linearGradient>
			<linearGradient id="prefix__swatch6">
				<stop offset={0} id="prefix__stop6" stopColor="currentColor" stopOpacity={1} />
			</linearGradient>
			<linearGradient
				xlinkHref="#prefix__swatch6"
				id="prefix__linearGradient6"
				x1={0}
				y1={10.76}
				x2={10.14}
				y2={10.76}
				gradientUnits="userSpaceOnUse"
			/>
			<linearGradient
				xlinkHref="#prefix__swatch7"
				id="prefix__linearGradient7"
				x1={11.38}
				y1={10.76}
				x2={21.52}
				y2={10.76}
				gradientUnits="userSpaceOnUse"
			/>
			<linearGradient
				xlinkHref="#prefix__swatch6"
				id="prefix__linearGradient8"
				gradientUnits="userSpaceOnUse"
				x1={0}
				y1={10.76}
				x2={10.14}
				y2={10.76}
			/>
			<linearGradient
				xlinkHref="#prefix__swatch6"
				id="prefix__linearGradient9"
				gradientUnits="userSpaceOnUse"
				x1={0}
				y1={10.76}
				x2={10.14}
				y2={10.76}
			/>
			<linearGradient
				xlinkHref="#prefix__swatch6"
				id="prefix__linearGradient10"
				gradientUnits="userSpaceOnUse"
				x1={0}
				y1={10.76}
				x2={10.14}
				y2={10.76}
			/>
			<linearGradient
				xlinkHref="#prefix__swatch7"
				id="prefix__linearGradient11"
				gradientUnits="userSpaceOnUse"
				x1={11.38}
				y1={10.76}
				x2={21.52}
				y2={10.76}
			/>
			<linearGradient
				xlinkHref="#prefix__swatch7"
				id="prefix__linearGradient12"
				gradientUnits="userSpaceOnUse"
				x1={11.38}
				y1={10.76}
				x2={21.52}
				y2={10.76}
			/>
			<linearGradient
				xlinkHref="#prefix__swatch7"
				id="prefix__linearGradient13"
				gradientUnits="userSpaceOnUse"
				x1={11.38}
				y1={10.76}
				x2={21.52}
				y2={10.76}
			/>
			<clipPath id="prefix__clippath">
				<path className="prefix__cls-1" id="prefix__rect1" d="M0 0h10.14v21.52H0z" />
			</clipPath>
			<clipPath id="prefix__clippath-1">
				<path className="prefix__cls-1" id="prefix__rect2" d="M11.38 0h10.14v21.52H11.38z" />
			</clipPath>
			<style id="style1">{'.prefix__cls-1{fill:none}'}</style>
		</defs>
		<g id="prefix__Livello_1-2" data-name="Livello 1">
			<g id="prefix__g13" transform="translate(1.74 1.74) scale(.95353)" fill="none" stroke="currentColor">
				<g clipPath="url(#prefix__clippath)" id="prefix__g4" fillOpacity={1}>
					<g id="prefix__g3" fill="none" fillOpacity={1} stroke="currentColor">
						<path d="M10.14 0H0v21.52h10.14z" id="prefix__path2" />
						<path d="M10.64 22.02H-.5V-.5h11.14zm-10.14-1h9.14V.5H.5z" id="prefix__path3" />
					</g>
				</g>
				<g clipPath="url(#prefix__clippath-1)" id="prefix__g6">
					<g id="prefix__g5" fill="none" stroke="currentColor">
						<path d="M21.52 0H11.38v21.52h10.14z" id="prefix__path4" />
						<path d="M22.02 22.02H10.88V-.5h11.14zm-10.14-1h9.14V.5h-9.14z" id="prefix__path5" />
					</g>
				</g>
			</g>
		</g>
	</svg>
))
GridAlternateIconMobSvg.displayName = 'GridAlternateIconMobSvg'

const GridAlternateIconMob = forwardRef((props, ref) => (
	<Icon component={GridAlternateIconMobSvg} ref={ref} {...props} />
))
GridAlternateIconMob.displayName = 'GridAlternateIconMob'

GridAlternateIconMob.defaultProps = {
	...Icon.defaultProps,
}
GridAlternateIconMob.propTypes = {
	...Icon.propTypes,
}

export default GridAlternateIconMob
export { GridAlternateIconMobSvg }
